import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { RouteComponentProps } from 'react-router-dom'
import { IonIcon, IonItem, IonLabel } from '@ionic/react'
import { chatboxEllipsesSharp } from 'ionicons/icons'

import { Tracking, TrackingEvent } from '@/lib/tracking'
import { Routes } from '@/router/routes'

import { SignInMethods } from '@/enums'
interface SignInWithPhoneNumberProps {
  history: RouteComponentProps['history']
}

const SignInWithPhoneNumber: FC<SignInWithPhoneNumberProps> = ({ history }) => {
  const { t } = useTranslation('common')

  return (
    <IonItem
      className="custom-item cursor-pointer mt-4"
      onClick={() => {
        history.push(Routes.AUTH_PHONE)
        Tracking.triggerEvent(TrackingEvent.SigninMethodSelected, {
          authMethod: SignInMethods.Phone,
        })
      }}
      detail={false}
    >
      <IonLabel>{t('registration.logInOptions.phoneOption')}</IonLabel>
      <IonIcon className="text-black" icon={chatboxEllipsesSharp} slot="end" />
    </IonItem>
  )
}

export default SignInWithPhoneNumber
